import { connect } from "react-redux";
import { industries as industriesList } from "_constants";
import { connect as formikConnect } from "formik";
import isEmpty from "lodash/isEmpty";
import { ownerCompany as ownerCompanySelector } from "selectors/company";

import Tenant from "./Tenant";

const mapStateToProps = (
  state,
  {
    formik: {
      values: { portfolio = {} },
    },
  }
) => {
  const ownerCompany = ownerCompanySelector(state) || portfolio.company || {};

  return {
    currentUserCompanyID: state.currentUser.company.id,
    industries: isEmpty(ownerCompany.industries) ? industriesList : ownerCompany.industries,
    ownerCompanyID: ownerCompany.id,
  };
};

export default formikConnect(connect(mapStateToProps)(Tenant));
